module.exports = __webpack_public_path__ + "static/media/icon-resources-selected.42698158.svg";